import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLocal } from '../api/content';

export const fetchLocal = createAsyncThunk(
  'content/fetchLocal',
  async (request) => {
// request.city
    request = { name: request.label}
    console.log('Request:', request);
    const raw = await getLocal( request);
    // Normalize any possible shape to an array:
    console.log('Response:', raw);
    const items =
      Array.isArray(raw?.items) ? raw.items :
      Array.isArray(raw)        ? raw :
      raw ? [raw] : [];

    return { items }; // always an array
  } 
);

const initialState = {
  location: { scope: 'city', state: 'California', county: 'Orange County', city: 'Dana Point', label: 'Dana Point' },
  activeTab: 'news',
  id: '',
  name: '',
  about: '',
  history: '',
  contacts: '',
  businesses: [],
  events: [],
  _initialized: false,
};

const localSlice = createSlice({
  name: 'local',
  initialState,
  reducers: {
    setLocation: (s, a) => { s.location = a.payload; },
    setLocalActiveTab: (s, a) => { s.activeTab = a.payload; },
  },
  extraReducers: (b) => {
    b.addCase(fetchLocal.fulfilled, (s, a) => {
      const p = a.payload || {};
      const loc = p.location || s.location;
      const item = p.item || p.items?.[0] || {};

      s.location   = loc;
      s.id         = item.id         ?? s.id;
      s.name       = item.name       ?? s.name;
      s.about      = item.about      ?? s.about;
      s.history    = item.history    ?? s.history;
      s.contacts   = item.contacts   ?? s.contacts;
      s.businesses = item.businesses ?? s.businesses;
      s.events     = item.events     ?? s.events;
      s._initialized = true;
      console.log('fetchLocal: item', item);
    });
  },
});

export const setLocation = (payload) => ({ type: 'local/setLocation', payload });

export function localReducer(state = initialState, action) {
  switch (action.type) {
    case 'local/setLocation':
      return {
        ...state,
        location: { ...state.location, ...action.payload }
      };
    default:
      return state;
  }
}

export const {  setLocalActiveTab } = localSlice.actions;
export default localSlice.reducer;

;

